import { render, staticRenderFns } from "./AllotPickUp.vue?vue&type=template&id=4f2499b0&scoped=true"
import script from "./AllotPickUp.vue?vue&type=script&lang=js"
export * from "./AllotPickUp.vue?vue&type=script&lang=js"
import style0 from "./AllotPickUp.vue?vue&type=style&index=0&id=4f2499b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2499b0",
  null
  
)

export default component.exports